module.exports = __webpack_public_path__ + "static/media/SF_nn_primaerlogo_agder_neg.8c7f46e5.pdf";